import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Forklift, AlertCircle } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      if (typeof detail === "string") setError(`[${status || "ERR"}] ${detail}`);
      else if (Array.isArray(detail)) setError(detail.map((d) => d.msg || JSON.stringify(d)).join(" "));
      else if (err.message) setError(`Network/Server: ${err.message}`);
      else setError("Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen bg-gray-50 flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-yellow-400 rounded-sm flex items-center justify-center mx-auto mb-4">
            <Forklift className="w-7 h-7 text-gray-900" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-gray-900">Admin Login</h1>
          <p className="text-sm text-gray-500 mt-1">Fork Finder</p>
          <p className="text-xs text-gray-400 mt-0.5">by Gesti&oacute;n Farcar</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-sm p-6 space-y-4" data-testid="admin-login-form">
          {error && (
            <div data-testid="login-error" className="flex items-center gap-2 text-sm text-red-600 bg-red-50 border border-red-200 rounded-sm p-3">
              <AlertCircle className="w-4 h-4 flex-shrink-0" /> {error}
            </div>
          )}
          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Email</label>
            <Input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="bg-white"
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-gray-700 mb-1 block">Password</label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="bg-white"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-yellow-400 text-gray-900 font-bold hover:bg-yellow-500 transition-colors px-6 py-3 rounded-sm disabled:opacity-50"
          >
            {loading ? "..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
